import React, { useState, useRef, useEffect } from 'react';

function GroupSelect({ groups, value, onChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const wrapperRef = useRef(null);

  const selectedGroup = groups.find(g => g.guid === value);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filteredGroups = groups.filter(group =>
    group.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelect = (group) => {
    onChange(group.guid);
    setIsOpen(false);
    setSearchTerm('');
  };

  return (
    <div className="custom-select" ref={wrapperRef}>
      <input
        type="text"
        className="custom-select-input"
        value={selectedGroup ? selectedGroup.name : ''}
        placeholder="Выберите группу"
        readOnly
        onClick={() => setIsOpen(!isOpen)}
      />
      {isOpen && (
        <div className="custom-select-dropdown active">
          <div className="custom-select-search">
            <input
              type="text"
              placeholder="Поиск по названию группы"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus
            />
          </div>
          <div className="custom-select-options">
            {filteredGroups.map((group) => (
              <div
                key={group.guid}
                className={`custom-select-option ${value === group.guid ? 'selected' : ''}`}
                onClick={() => handleSelect(group)}
              >
                {group.name}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default GroupSelect;






